<div class="coverage__wrapper">
  @if(coverage()){
  <div class="coverage__wrapper__title">
    <div>{{ coverage()?.title }}</div>
    @if (coverage()?.recommended) {
    <div><app-recommended-badge /></div>
    }
  </div>
  <div class="coverage__wrapper__content">
     <app-coverage-price [coverage]="coverage()" [currency]="currency()"/>
    
    @if (!isDetailOpen()) {
    <div class="mt-5">
      <a (click)="toggleDetailOpen()" (keydown)="toggleDetailOpen()" tabindex="0">Ver detalle</a>
    </div>
    }

    @if (isDetailOpen()) {
    <div class="text-sm py-5 text-left flex flex-col items__wrapper">
      @for ( item of coverage()?.items; track item.name ) {
      <div>- {{ item.name }}

        @if(item.insuredCapital){
        {{item.insuredCapital! | currencyFormat: 'ARS'}}
        }
      </div>
      }
    </div>
    <a (click)="toggleDetailOpen()" (keydown)="toggleDetailOpen()" tabindex="0">Ocultar detalle</a>
    }
  </div>
  }
</div>